import React from 'react';
import { Card, CardContent } from './ui/card';
import { Target, Award, Clock } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Target: Target,
  Award: Award,
  Clock: Clock
};

const CompetitiveAdvantages = () => {
  const { competitiveAdvantages } = mockData;

  return (
    <section id="advantages" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
            Why Choose GaaS
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-6 mb-4">
            Systematic Competitive Advantages
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Proven superiority through primary source validation and expert networks
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {competitiveAdvantages.map((advantage) => {
            const Icon = iconMap[advantage.icon];
            return (
              <Card
                key={advantage.id}
                className="border-2 border-gray-100 hover:border-blue-200 hover:shadow-xl transition-all duration-300 group cursor-pointer text-center"
              >
                <CardContent className="p-8">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-2xl mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                    <Icon className="w-10 h-10 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  
                  <div className="text-5xl font-bold text-blue-600 mb-3">{advantage.value}</div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{advantage.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="bg-blue-50 border-2 border-blue-100 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Transform cultural complexity into systematic competitive advantage
            </h3>
            <p className="text-gray-600 mb-6">
              Improve Business Ethics, Transparency & Cultural Intelligence through next-generation governance infrastructure
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:partnerships@gaas-platform.com"
                className="inline-flex items-center justify-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-200 hover:shadow-lg"
              >
                partnerships@gaas-platform.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompetitiveAdvantages;